(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nocellara-box-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-nbox]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-card]')];
    const button = root.querySelector('[data-add]');
    if (!button) return;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'it', {style:'currency',currency:root.dataset.currency || 'EUR'});
    const money = cents => formatter.format(cents / 100);
    const mobileButton = root.querySelector('[data-mobile-add]');
    const mobileBar = root.querySelector('[data-mobile-bar]');
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => {mobileBar.hidden=!entries[0].isIntersecting;}).observe(root);
    root.querySelectorAll('[data-filter]').forEach(filter => filter.addEventListener('click', () => {
      root.querySelectorAll('[data-filter]').forEach(other => other.setAttribute('aria-pressed',String(other===filter)));
      cards.forEach(card => {card.hidden=filter.dataset.filter!=='all' && card.dataset.category!==filter.dataset.filter;});
    }));
    mobileButton.addEventListener('click',()=>button.click());
    const originalText = button.textContent;
    let busy = false;
    const selection = () => cards.map(card => ({card,quantity:Math.max(0,Math.min(99,Math.floor(Number(card.querySelector('[data-qty]').value) || 0)))})).filter(item => item.quantity > 0);
    const update = () => {
      const chosen = selection();
      const list = root.querySelector('[data-selected]');
      list.replaceChildren();
      let subtotal = 0;
      chosen.forEach(({card,quantity}) => {
        subtotal += quantity * Number(card.dataset.price);
        const li = document.createElement('li');
        li.textContent = quantity + ' × ' + card.dataset.name + ' · ' + money(quantity * Number(card.dataset.price));
        list.appendChild(li);
      });
      root.querySelector('[data-empty]').hidden = chosen.length > 0;
      root.querySelector('[data-subtotal]').textContent = money(subtotal);
      root.querySelector('[data-total]').textContent = money(subtotal + Number(root.dataset.wrapPrice));
      button.disabled = busy || !chosen.length;
      mobileButton.disabled=button.disabled;
      mobileButton.textContent=busy?root.dataset.busy:root.dataset.addShort;
      root.querySelector('[data-mobile-total]').textContent=money(subtotal + Number(root.dataset.wrapPrice));
    };
    root.addEventListener('input', event => {if(event.target.matches('[data-qty]')) update();});
    root.addEventListener('change', event => {if(event.target.matches('[data-qty]')) {event.target.value=String(Math.max(0,Math.min(99,Math.floor(Number(event.target.value)||0))));update();}});
    button.addEventListener('click', async () => {
      const chosen = selection();
      if (busy || !chosen.length) return;
      busy = true;update();button.textContent=root.dataset.busy;
      const boxId = 'box-' + Date.now() + '-' + Math.random().toString(36).slice(2,8);
      const properties = {[root.dataset.boxLabel]:root.dataset.customLabel,'_box_id':boxId};
      const items = chosen.map(({card,quantity}) => ({id:Number(card.dataset.id),quantity,properties}));
      items.push({id:Number(root.dataset.wrap),quantity:1,properties});
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if (!response.ok) throw new Error('cart');
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch(error) {
        root.querySelector('[data-message]').textContent=root.dataset.error;
        busy=false;button.textContent=originalText;update();
      }
    });
    update();
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
